import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface GusData {
    readonly tin: string;
    readonly name: string;
    readonly voivodeship: string;
    readonly zipCode: string;
    readonly city: string;
    readonly postOfficeCity: string;
    readonly street: string;
    readonly houseNumber: string;
    readonly apartmentNumber: string;
    readonly email: string;
    readonly www: string;
    readonly phone: string;
}

interface GusDataInternalItem {
    readonly apartmentNumber: string;
    readonly atypicalLocation: string;
    readonly city: string;
    readonly commune: string;
    readonly companyName: string;
    readonly county: string;
    readonly email: string;
    readonly houseNumber: string;
    readonly nip: string;
    readonly phone: string;
    readonly post: string;
    readonly street: string;
    readonly voivodeship: string;
    readonly www: string;
    readonly zipCode: string;
}

export class GusDataByTinQuery extends Query<GusData> {
    public constructor(public readonly tin: string) {
        super();
    }
}

export const GusUnavailableErrorCode = 'GusUnavailable';
export const GusTechnicalBreakCode = 'GusTechnicalBreak';

export class GusDataByTinQueryHandlerBase implements QueryHandler<GusDataByTinQuery, GusData> {
    private static Timeout = 1000 * 60 * 5;
    private static Url = TaggedUrl.join('gus/:tin', [Tags.Api, Tags.NotHandle404, Tags.NotHandle5xx]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(query: GusDataByTinQuery): Promise<GusData> {
        const url = fillPlaceholders(GusDataByTinQueryHandlerBase.Url, { tin: query.tin });
        const { data } = await this.http.get<GusDataInternalItem>(url, { timeout: GusDataByTinQueryHandlerBase.Timeout });
        return {
            tin: data.nip,
            name: data.companyName,
            voivodeship: data.voivodeship,
            zipCode: data.zipCode,
            city: data.city,
            postOfficeCity: data.post,
            street: data.street,
            houseNumber: data.houseNumber,
            apartmentNumber: data.apartmentNumber,
            email: data.email,
            www: data.www,
            phone: data.phone
        };
    }
}
